import React, { useEffect, useState, useRef, memo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';
// import { translation } from '@carrier-ecat/ngecat-reactcomponents';
import '../../App.scss';
import { Button, Tooltip } from '@material-ui/core';
import {logoutMakeTokenInactive} from '@carrier-sce-sharedpackages/auth-module';
import {appConfig} from "../../appConfig";

const ProfileDropdown = (props) => {
	const node = useRef();
	const [open, setOpen] = useState(false);
	const [openDialouge, setOpenDialouge] = useState(false);
	const fullName = props?.permission?.firstName + ' ' + props?.permission?.lastName
	const loggedInUserEmail = props?.permission?.emailAddress
	localStorage.setItem("userEmailAddress",loggedInUserEmail);
	const handleClick = (e) => {
		if (node.current.contains(e.target)) {
			return;
		}
		setOpen(false);
	};
	const handleChange = (selectedValue) => {
		setOpenDialouge(true);
		setOpen(false);
	};
	const handleChangeOfRoles = (selectedObj) => {
		props.onChange(selectedObj);
	};
	const handleSignOut = () => {
		appLogout();	
	};
	
	const appLogout = () => {
		const token = localStorage.getItem('msal.idtoken');
		logoutMakeTokenInactive(appConfig, false, token);
	};

	const toggleDialog = () => {
		setOpenDialouge(false);
	};

	useEffect(() => {
		document.addEventListener('mousedown', handleClick);

		return () => {
			document.removeEventListener('mousedown', handleClick);
		};
	}, []);

	const UserNameButton = () => {
		const userNameInitials = fullName
			.split(' ')
			.splice(0, 2)
			.map((i) => i.charAt(0))
			.join('');
		return (
			<Tooltip title={props.fullName}>
				<Button
					role='button'
					className='user-name-button'
					onClick={(e) => setOpen(!open)}
				>
					{userNameInitials}
				</Button>
			</Tooltip>
		);
	};

	return (
		<div ref={node} className='dropdown' id='profiledd' data-label='profiledd'>
			<UserNameButton />
			{open && (
				<ul className='dropdown-menu listWidth'>
					<li>
						<p class='dropdown-switch-title'>
							Welcome {fullName}
						</p>
						<ul className='dropdown-switch'>
							{props?.roles?.map((opt, idx) => (
								<li id={opt}
									className={
										opt === props.role ? 'active' : ''
									}
									key={idx}
									onClick={(e) => handleChangeOfRoles(opt)}
								>
									{/* {translation(FormatTransKey(opt))} */}
								</li>
							))}
						</ul>
					</li>
					{/* <li id='AboutEcatLink' onClick={(e) => handleChange()}>
						<FontAwesomeIcon icon={faInfoCircle} />
						{translation('AboutNGECat')}
					</li>
					<li>
						<p class='dropdown-switch-title'>Units</p>
						<SettingDropdown
							selectedItem={props.selectedUnit}
							onchange={props.onUnitChange}
						/>
					</li>
					<LangDropdown
						selectedItem={props.selectedLanguage}
						options={props.languageOptions}
						onChange={props.onLanguageChange}
					/> */}
					<li id='LogOutLink' onClick={(e) => handleSignOut()}>
							<span> Logout </span>
						<FontAwesomeIcon icon={faLock} />
						{/* {translation('LogOutDropdownItem')} */}
					</li> 
				</ul>
			)}
			{/* <AboutEcat openDialouge={openDialouge} onClose={toggleDialog} /> */}
		</div>
	);
};

export default memo(ProfileDropdown);
